import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69858b98921dc90014dd9abd/carrizoperezlaw/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69858b98921dc90014dd9abd/carrizoperezlaw/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69858b98921dc90014dd9abd/carrizoperezlaw/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69858b98921dc90014dd9abd/carrizoperezlaw/src/components/ui/AppImage.tsx");
